import script from "./TotaisReceitasChart.vue?vue&type=script&setup=true&lang=js"
export * from "./TotaisReceitasChart.vue?vue&type=script&setup=true&lang=js"

import "./TotaisReceitasChart.vue?vue&type=style&index=0&id=7434a490&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7434a490"]])

export default __exports__